import { useLanguage } from '../i18n/LanguageContext';
import { LEGAL, UI, LAST_UPDATED } from './legalContent';

export default function LegalPage({ doc }) {
  const { language } = useLanguage();
  const lang = LEGAL[doc][language] ? language : 'en';
  const page = LEGAL[doc][lang];

  return (
    <div className="min-h-screen" data-testid={`legal-page-${doc}`}>
      <section className="gradient-hero pt-32 md:pt-40 pb-12 md:pb-16">
        <div className="container-max px-6 md:px-12 lg:px-24">
          <div className="max-w-3xl">
            <h1 className="text-h1 text-slate-900 mb-4" data-testid="legal-title">{page.title}</h1>
            <p className="text-sm text-slate-500" data-testid="legal-updated">{UI[lang].updated}: {LAST_UPDATED[lang]}</p>
          </div>
        </div>
      </section>
      <section className="py-16 md:py-20 bg-white">
        <div className="container-max px-6 md:px-12 lg:px-24">
          <div className="max-w-3xl space-y-8 text-slate-700 leading-relaxed">
            <div className="space-y-1 text-sm" data-testid="legal-intro">
              {page.intro.map(([k, v]) => (
                <p key={k}><span className="font-semibold text-slate-900">{k}:</span> {v}</p>
              ))}
            </div>
            <ol className="space-y-6">
              {page.sections.map(([heading, body], i) => (
                <li key={heading} data-testid={`legal-section-${i + 1}`}>
                  <h2 className="text-base md:text-lg font-semibold text-slate-900 mb-2">{i + 1}. {heading}</h2>
                  <p>{body}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>
    </div>
  );
}
